const API_URL = process.env.REACT_APP_BACKEND_URL || ''

export async function apiRequest(endpoint, options = {}) {
  const token = localStorage.getItem('admin_token')
  
  const headers = {
    'Content-Type': 'application/json',
    'X-Environment': 'production',
    ...(token && { 'Authorization': `Bearer ${token}` }),
    ...options.headers
  }

  const res = await fetch(`${API_URL}${endpoint}`, {
    ...options,
    headers
  })

  if (!res.ok) {
    const error = await res.json().catch(() => ({ detail: 'Request failed' }))
    throw new Error(error.detail || 'Request failed')
  }

  return res.json()
}

// SWR fetcher function
export const fetcher = (url) => apiRequest(url)
